import { render, staticRenderFns } from "./CreateServiceModal.vue?vue&type=template&id=71e5c130&scoped=true&"
import script from "./CreateServiceModal.vue?vue&type=script&lang=ts&"
export * from "./CreateServiceModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateServiceModal.vue?vue&type=style&index=0&id=71e5c130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e5c130",
  null
  
)

export default component.exports